<template>
  <lwf-autocomplete
    :value="value"
    :options="agents"
    v-bind="vAttrs"
    v-on="vListeners"
  >
    <template #option="scope">
      <q-item
        v-ripple
        v-bind="scope.itemProps"
        v-on="scope.itemEvents"
      >
        <q-item-section>
          <q-item-label>
            {{ scope.opt | userName }}
          </q-item-label>
        </q-item-section>
        <q-item-section side>
          <lwf-badge-bool
            v-if="!scope.opt.enabled"
            :value="scope.opt.enabled"
            :labels="['Désactivé', 'Activé']"
          />
        </q-item-section>
      </q-item>
    </template>
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        :name="k"
        v-bind="props"
      />
    </template>
  </lwf-autocomplete>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import { modalAgent } from '@/utils/ui/modal'
import { plz } from '@/utils'
import { userName } from '@/utils/data/agents'
import { ACCOUNT_RIGHT_CREATE_AGENT } from '@/consts/rights'
import LwfBadgeBool from 'components/core/LwfBadgeBool'
import validateProxyMixin from '@/mixins/validateProxyMixin'

const storeUser = createNamespacedHelpers('user')
const storeUserAgency = createNamespacedHelpers('user/agency')
export default {
  name: 'AutocompleteAgent',
  components: { LwfBadgeBool, LwfAutocomplete },
  filters: {
    userName
  },
  mixins: [validateProxyMixin],
  props: {
    value: {
      type: [String, Object, Array],
      default: undefined
    },
    multiple: Boolean,
    allToggle: Boolean,
    /**
     * Autorise la création d'agent
     **/
    allowAdd: Boolean
  },
  computed: {
    ...storeUser.mapGetters({
      isGranted: 'isGranted'
    }),
    ...storeUserAgency.mapGetters({
      agents: 'agents'
    }),
    ...storeUserAgency.mapState({
      fetching: 'fetching'
    }),
    vOn () {
      const on = {}
      if (this.allowAdd && this.isGranted(ACCOUNT_RIGHT_CREATE_AGENT)) {
        on.ajouter = this.onAjouter
      }
      return on
    },
    vListeners () {
      return {
        ...this.$listeners,
        ...this.vOn
      }
    },
    vAttrs () {
      const { multiple } = this
      return {
        label: plz('Agent', multiple),
        'option-label': userName,
        'hide-selected': !multiple,
        'use-chips': multiple,
        loading: this.fetching.agents === true,
        multiple,
        ...this.$attrs
      }
    }
  },
  methods: {
    onAjouter () {
      modalAgent()
    }
  }
}
</script>

<style scoped>

</style>
